const Template = require('./template')
const utils = require('./utils')

const SlotModel = ({
  config,
  slot,
  booking,
}) => {
  booking = booking || {}
  const bookingData = booking.data || {}
  const reference = booking.reference || ''
  const render = Template({
    slot,
    config,
    options: bookingData.options || {},
    details: bookingData.details || {},
    reference,
  })

  const isBlocked = () => utils.isSlotBlocked(slot)
  const isAdminOnly = () => utils.isSlotAdminOnly(slot)
  const canBook = () => render.context.canBook()
  const getTotals = () => render.context.getTotals()
  const getPlatformFee = () => Math.round(render.context.getPlatformFee())
  const getBookingFee = () => Math.round(render.context.getBookingFee())
  const getGrandTotal = () => render.context.getGrandTotal()
  const getDeposit = () => render.context.getDeposit()
  const getDepositTitle = () => render.context.getDepositTitle()
  const getPayNow = () => render.context.getPayNow()
  const getPayNowTitle = () => render.context.getPayNowTitle()
  const getCustomerEmail = () => render.context.getCustomerEmail()

  return {
    render,
    isBlocked,
    isAdminOnly,
    canBook,
    getTotals,
    getPlatformFee,
    getBookingFee,
    getGrandTotal,
    getDeposit,
    getDepositTitle,
    getPayNow,
    getPayNowTitle,
    getCustomerEmail,
  }
}

module.exports = SlotModel